import { useMemo } from 'react'
import { AI360DynamicEmsData } from '../types'
import { useDynamicEmsData } from 'src/Libs/dynamic-power-prices/hooks/dynamic-ems/use-dynamic-ems-data'
import { convertDynamicEmsData } from '../utils/merge-line-chart-data'

interface Props {
  installationId: string | undefined
  /* The time range for which to fetch  dynamic ems data */
  from: Date
  to: Date
}

/**
 * hook for fetching dynamic EMS data for AI360.
 * it fetches data for a specific installation and time range.
 * converts the data into a format suitable for the AI360 line chart, filling in missing data points based on a fixed resolution (15 minutes).
 */
export const useAI360DynamicEmsData = ({ installationId, from, to }: Props): AI360DynamicEmsData[] => {
  const fromISO = useMemo(() => from.toISOString(), [from])
  const toISO = useMemo(() => to.toISOString(), [to])

  const { data } = useDynamicEmsData(installationId, fromISO, toISO)

  const dynamicEmsData = convertDynamicEmsData({ dynamicEmsData: data ?? [], from, to })

  return dynamicEmsData
}
